import { Box, styled } from '@withjoy/joykit';

export const BookingContainer = styled(Box)`
  border-radius: 16px;
  border: solid 1px ${props => props.theme.colors.mono3};
`;
